import React, { useState } from 'react'

import { useTheme } from 'styled-components'

import { SheetModal } from '@components/SheetModal'
import { SheetModalHandle } from '@components/SheetModalHandle'
import { useAddTaskComment } from '@hooks/comments'
import { useEditTaskFieldAndTaskList } from '@hooks/task/patch/editFieldAndList'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'

import {
  Container,
  InputContainer,
  InputField,
  InputInformationText,
  TaskInformationLabel,
} from './styles'

type TTaskProps = Pick<
  IGenericTask,
  'id' | 'workOrder' | 'code' | 'name' | 'status'
>

interface IProps {
  openModal: boolean
  onClose: () => void
  task: TTaskProps
}

export function SapCommentsModal({ openModal, onClose, task }: IProps) {
  const theme = useTheme()
  const [comment, setComment] = useState('')

  const { mutateAsync: patchTask } = useEditTaskFieldAndTaskList()
  const { mutateAsync: postTaskComment } = useAddTaskComment()

  const handle = () => (
    <SheetModalHandle
      showButtons
      onCancelButton={handleCancelPress}
      onSaveButton={handleOnSave}
      isSaveEnabled={!!comment}
    >
      <span>Add SAP Comments</span>
    </SheetModalHandle>
  )

  function handleOnSave() {
    if (!comment) return

    handleSaveSapComment(comment)
    setComment('')
  }

  function handleCancelPress() {
    setComment('')
    onClose()
  }

  function handleSaveSapComment(comment: string) {
    postTaskComment({
      comment,
      taskId: task.id,
      isSapComment: true,
    })

    patchTask({
      id: task.id,
      changes: { status: task.status },
    })
  }

  return (
    <SheetModal
      handle={handle}
      initialSnap={2}
      onClose={onClose}
      open={openModal}
    >
      <Container>
        <div>
          <TaskInformationLabel>Task Name: {task.name}</TaskInformationLabel>

          <TaskInformationLabel>Code: {task.code}</TaskInformationLabel>
          <TaskInformationLabel>
            WorkOrder: {task.workOrder}
          </TaskInformationLabel>
        </div>

        <InputContainer>
          <InputInformationText>
            Your organization requires comments to assist in closing work item
            in SAP (measurement points, repair comments, etc). Please add
            comments as required otherwise this action will be cancelled.
          </InputInformationText>
          <InputField
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value)}
            placeholder="Please, add a SAP comment..."
            value={comment}
          />
        </InputContainer>
      </Container>
    </SheetModal>
  )
}
